import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const templatesApi = createApi({
  reducerPath: "templatesApi",
  baseQuery: customFetchBase,
  tagTypes: ["Templates"],
  endpoints: () => ({}),
});
